// extracted by mini-css-extract-plugin
export default {"experience-slider":"Experience_experience-slider__J-rc2","title":"Experience_title__sPDxY"};